<template>
<div>
  <div id="baseInfoEdit" v-if="editFlag">
      <!--基本信息编辑-->
      <div id="inforView" class="pt15" >
        <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;">
          <el-col :span="24">
            <strong style="color: #2452ff;">基本信息</strong>
          </el-col>
        </el-row>
        <el-form class="el-form demo-form-inline" ref="baseInforForm" :model="baseInforForm" label-width="150px" label-position="right" :rules="baseInforRules">
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="zwgsmc" label="中文公司名称">
                <el-input size="small" v-model="baseInforForm.zwgsmc" placeholder="中文公司名称" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="gsjc" label="公司简称">
                <el-input size="small" v-model="baseInforForm.gsjc" placeholder="公司简称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="ywgsmc" label="英文公司名称">
                <el-input size="small" v-model="baseInforForm.ywgsmc" placeholder="英文公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="ywgsjc" label="英文公司简称">
                <el-input size="small" v-model="baseInforForm.ywgsjc" placeholder="英文公司简称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="zcdz" label="公司注册地址">
                <el-input size="small" v-model="baseInforForm.zcdz" placeholder="公司注册地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
                <el-form-item prop="wz" label="网址">
                  <el-input size="small" v-model="baseInforForm.wz" placeholder="网址"></el-input>
                </el-form-item>
              </el-col>
          </el-row>
          
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="bgdh" label="办公电话">
                <el-input size="small" v-model="baseInforForm.bgdh" maxlength="50" placeholder="办公电话" style="width:78%;float:left"></el-input>
                <div style="width:5%;display:inline;float:left;text-align: center">
                  <p style="font-size: 14px;color: #606266;line-height: 40px;">-</p>
                </div>
                <el-input size="small" v-model="baseInforForm.bgdhfjh" maxlength="50" placeholder="分机号" style="width:17%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <!-- <el-col :span="11">
              <el-form-item prop="cz" label="传真">
                <el-input size="small" v-model="baseInforForm.cz" placeholder="传真"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="11" v-if="userType=='ZSYH'">
              <el-form-item prop="dzyx1" label="密码找回邮箱">
                <el-input size="small" v-model="baseInforForm.dzyx1" placeholder="密码找回邮箱" @change="dzyxChange()">
                  <el-button id="mail-btn" :disabled=mailBtnDisable slot="append" @click="openYxYz" v-text=mailCodeText></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" v-else>
              <el-form-item prop="dzyx1" label="密码找回邮箱">
                <el-input size="small" v-model="baseInforForm.dzyx1" placeholder="密码找回邮箱" @change="dzyxChange()">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="lxr" label="联系人">
                <el-input size="small" v-model="baseInforForm.lxr" placeholder="联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11" v-if="userType=='ZSYH'">
              <el-form-item prop="lxrsj" label="手机">
                <el-input disabled size="small" v-model="baseInforForm.lxrsj" placeholder="手机">
                  <el-button slot="append" @click="openSjYz">修改</el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" v-else>
              <el-form-item prop="lxrsj" label="手机">
                <el-input size="small" v-model="baseInforForm.lxrsj" placeholder="手机">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="frdb" label="备用联系人">
                <el-input size="small" v-model="baseInforForm.frdb" placeholder="备用联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="frdbdh" label="备用联系人手机">
                <el-input size="small" v-model="baseInforForm.frdbdh" placeholder="备用联系人手机"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          
          <el-row class="tr mb5">
            <el-col :span="23">
              <span style="color:red">提示：备用联系人不能和联系人是同一人，将用在出差、休假等情况下，展会事宜的联系</span>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="xzqh" label="合同邮寄（省市）">
                <el-cascader id="ShengShiCascader" :options="xzqhDataTree" :props="defaultProps" size="small" v-model="baseInforForm.xzqh" placeholder="合同邮寄地址（省/市）" class="searchSelect" clearable show-all-levels></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="yjdzxx" label="合同邮寄详细地址">
                <el-input size="small" v-model="baseInforForm.yjdzxx" placeholder="合同邮寄详细地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="11">
              <el-form-item prop="yjlxr" label="邮寄联系人">
                <el-input size="small" v-model="baseInforForm.yjlxr" placeholder="邮寄联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
           
            <el-col :span="11" >
              <el-form-item prop="yjlxrsj" label="邮寄联系人手机">
                <el-input size="small" v-model="baseInforForm.yjlxrsj" placeholder="邮寄联系人手机">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;">
            <el-col :span="24">
              <strong style="color: #2452ff;">
                <span style="color: red">*</span>&nbsp;营业执照</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-upload
              class="avatar-uploader"
              ref="uploadPics"
              :headers="myHeaders"
              :action="yyzzUploadAction"
              :data="upLoadData"
              :on-success="picSuccess"
              :before-upload="PicChange"
              :show-file-list="false"
              accept=".jpg,.png,.pdf"
              >
                <img v-if="baseInforForm.src!=='' && baseInforForm.src!==null" :src="baseInforForm.imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__tip" slot="tip">jpg/png、单页pdf文件，且小于5MB</div>
              </el-upload>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="buttonSubmit">
            <el-col :span="24">
              <el-button v-if="jbxxData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">取消</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitJbxx('baseInforForm')">保存</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--手机验证dialog-->
      <el-dialog title="手机号码验证" :visible.sync="dialogSjFormVisible" @close="closeDialog()" :close-on-click-modal="false">
        <el-form class="el-form demo-form-inline" ref="sjform" :model="sjform" label-position="right" label-width="120px" :rules="sjformRules">
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="sjh" label="手机号">
                <el-input size="small" v-model="sjform.sjh" placeholder="手机号">
                  <el-button id="mobile-btn" slot="append" @click="getMessageCode()" v-text=messageCodeText :disabled=mobileBtnDisable></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="yzm" label="短信验证码">
                <el-input size="small" v-model="sjform.yzm" placeholder="短信验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="closeDialog(sjform)">取消</el-button>
          <el-button size="small" type="primary" @click.native="sjformSubmit(sjform)">提交</el-button>
        </div>
      </el-dialog>
      <!--邮箱验证dialog-->
      <el-dialog title="邮箱验证" :visible.sync="dialogYxFormVisible" @close="closeYxDialog()" :close-on-click-modal="false">
        <el-form class="el-form demo-form-inline" ref="yxform" :model="yxform" label-width="120px" label-position="right">
          <el-row class="tr mb5" style="text-align: left;margin-left: 10px">
            请输入邮箱
            <span v-text="this.baseInforForm.dzyx1" style="font-style:italic;margin-right: 2px;"></span>收到的验证码
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="22">
              <el-form-item prop="yzm" label="验证码">
                <el-input size="small" v-model="yxform.yzm" placeholder="验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="closeYxDialog()">取消</el-button>
          <el-button size="small" type="primary" @click.native="yxformSubmit()">提交</el-button>
        </div>
      </el-dialog>
  </div>

  <!--详情展示-->
      <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
        <!--企业基本信息-->
        <div id="qyjbxx" class="mb5">
          <el-row>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="21">
              <el-row>
                <el-col :span="12">
                  <strong class="vt">营业执照：</strong>
                  <img v-if="jbxxData.imageUrl!==''" :src="jbxxData.imageUrl" @click="imgPreview(jbxxData.imageUrl)" style="max-width:100%;max-height:140px;" class="poi">
                  <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
                </el-col>
                <el-col :span="12">
                  <el-row class="mb10">
                    <strong>办公电话：</strong>
                    <span v-text="jbxxData.bgdh||'无'"></span>
                  </el-row>
                  <el-row class="mb10">
                    <strong>网址：</strong>
                    <span v-text="jbxxData.wz||'无'"></span>
                  </el-row>
                  <el-row class="mb10">
                    <strong>电子邮箱：</strong>
                    <span v-text="jbxxData.dzyx||'无'"></span>
                  </el-row>
                  <el-row class="mb10">
                    <strong>公司注册地址：</strong>
                    <span v-text="jbxxData.zcdz||'无'"></span>
                  </el-row>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>中文公司名称：</strong>
                  <span v-text="jbxxData.zwgsmc||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>英文公司名称：</strong>
                  <span v-text="jbxxData.ywgsmc||'无'"></span>
                </el-col>
              </el-row>
              
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>联系人：</strong>
                  <span v-text="jbxxData.lxr||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>联系人手机：</strong>
                  <span v-text="jbxxData.lxrsj||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                    <strong>备用联系人：</strong>
                    <span v-text="jbxxData.frdb||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>备用联系人手机号码：</strong>
                  <span v-text="jbxxData.frdbdh||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                  <strong>合同邮寄地址：</strong>
                  <span v-text="jbxxData.yjdz||'无'"></span>
                </el-col>
              </el-row>
              <el-row class="mb10">
                <el-col :span="12">
                    <strong>合同邮寄联系人：</strong>
                    <span v-text="jbxxData.yjlxr||'无'"></span>
                </el-col>
                <el-col :span="12">
                  <strong>合同邮寄联系人手机号码：</strong>
                  <span v-text="jbxxData.yjlxrsj||'无'"></span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">编辑</el-button>
            </el-col>
          </el-row>
        </div>
        <!--图片预览-->
        <el-dialog id="previewImgDialog" :visible.sync="showPicVisible" :close-on-click-modal="false" size="tiny">
          <img :src="previewImg" width="100%" class="mt15">
        </el-dialog>
      </div>
</div>
  
</template>

<script>
export default {
  props:{
    qyid: {
      type: String,
      required: true
    },
  
  },
  name: "baseInfoEdit",
  data() {
    return {
      baseUrl: window.config.baseUrl,
      myHeaders: { XTOKEN: localStorage.getItem("XTOKEN") },
      //上传图片路径配置
      yyzzUploadAction :window.config.domain+'/qyjbxx/upload',
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      userType: this.CONSTANT.currentUser.deptid,
      //状态 0新增
      jbxxStatus: 0,

      //要删除的图片路径list
      delPicList: [],
      //上传后未保存的图片list
      unsavedPicList: [],
      //基本信息表单
      baseInforForm: {
        zwgsmc: "",
        ywgsmc: "",
        frdb: "",
        frdbdh: "",
        yjdzsheng: "",
        yjdzshi: "",
        yjdzxx: "",
        bgdh: "",
        bgdhfjh:"",
        cz: "",
        lxr: "",
        lxrsj: "",
        wz: "",
        dzyx: "",
        dzyx1: "",
        yyzzgs: "",
        src: "",
        imageUrl: "",
        gsjc:"",
        ywgsjc:"",
        zcdz:"",
        yjlxr:"",
        yjlxrsj:""
      },
      //手机验证表单显示标识
      dialogSjFormVisible: false,
      //邮箱表单显示标识
      dialogYxFormVisible: false,
      //邮箱验证flag
      mailCheck: false,
      //邮箱验证按钮可用flag
      mailBtnDisable: false,
      //手机验证按钮可用flag
      mobileBtnDisable: false,
      //上传的文件为pdf标识
      isPdf: false,
      //通过验证的邮箱地址（记录以防验证后修改邮箱）
      checkedMailAddress: "",
      //短信验证按钮文字
      messageCodeText: "获取验证码",
      //短信验证码
      messageCodeReal: "",
      //邮箱验证码
      mailCodeReal: "",
      //邮箱验证按钮文字
      mailCodeText: "验证",
      time: 60,
      timer: null,
      time2: 60,
      timer2: null,

      //行政区划tree
      xzqhDataTree: [],
      //树结构配置
      defaultProps: {
        children: "children",
        label: "codeName",
        value: "codeValue"
      },
      //上传图片Data
      fileList: [],
      //上传加参数
      upLoadData: {
        qyid: ""
      },
     
      //公司logo
      imageUrl: "",
      
      //曾用公司名称
      cygsmc: "",
      //手机验证表单
      sjform: {
        sjh: "",
        yzm: ""
      },
      yxform: {
        yzm: ""
      },
      baseInforRules: {
        zwgsmc: [
          { required: true, message: "请输入中文公司名称", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        ywgsmc: [
          { required: true, message: "请输入英文公司名称", trigger: "blur" },
          /*
          {
            pattern: /^[a-z\d\.\,\，\|\-\(\)\'\!\<\>\_\*\&\（\） ]+$/i,
            message: "英文公司名称只能输入字母、空格、括号和 .,-|",
            trigger: "blur"
          },*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('请输入英文字符'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          { min: 1, max: 100, message: "最多可输入100个字符", trigger: "blur" }
        ],
        xzqh: [
          { required: true, message: "请选择合同邮寄地址省市", trigger: "change" }
        ],
        yjdzxx: [
          { required: true, message: "请输入合同邮寄详细地址", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        zcdz: [
          { required: true, message: "请输入公司注册地址", trigger: "blur" },
          { min: 1, max: 150, message: "最多可输入150个字", trigger: "blur" }
        ],
        bgdh: [
          { required: true, message: "请输入办公电话", trigger: "blur" },
          { min: 1, max: 25, message: "最多可输入25个字", trigger: "blur" }
          ],
        frdb: [
          { required: true, message: "请输入备用联系人", trigger: "blur" },
          { min: 1, max: 25, message: "最多可输入25个字", trigger: "blur" }
        ],
        frdbdh: [
          { required: true, message: "请输入备用联系人手机号码", trigger: "blur" },
        //  { pattern: /^[0-9]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 15, message: "最多可输入15个字", trigger: "blur" },

        ],
        cz: [
        //  { pattern: /^[0-9]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 30, message: "最多可输入30个字", trigger: "blur" }
        ],
        lxr: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 1, max: 25, message: "最多可输入25个字", trigger: "blur" }
        ],
        yjlxr: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 1, max: 25, message: "最多可输入25个字", trigger: "blur" }
        ],
        lxrsj: [
          { required: true, message: "请输入邮寄联系人手机号码", trigger: "blur" },
        //  { pattern: /^[0-9]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 15, message: "最多输入15个字", trigger: "blur" }
        ],
        yjlxrsj: [
          { required: true, message: "请输入邮寄联系人手机号码", trigger: "blur" },
        //  { pattern: /^[0-9]*$/, message: "只能输入数字", trigger: "blur" },
          { min: 1, max: 15, message: "最多输入15个字", trigger: "blur" }
        ],
        wz: [
          { required: false, message: "请输入网址", trigger: "blur" },
          { min: 1, max: 100, message: "最多可输入100个字", trigger: "blur" }
        ],
        dzyx1: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
        /*  {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          },
        */
       /*   {
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@[0-9A-Za-z]+(?:\.[0-9A-Za-z]+)+$/,
            message: "仅支持数字和字母组合的邮箱地址，最多可连续出现一个连接符",
            trigger: "blur"
          },*/
          { min: 1, max: 30, message: "最多输入30个字符", trigger: "blur" }
        ],
        gsjc:[
          { required: true, message: "请输入公司简称", trigger: "blur" },
          { min: 1, max: 4, message: "最多输入4个字", trigger: "blur" }
        ],
        ywgsjc: [
          { required: true, message: "请输入英文公司简称", trigger: "blur" },
          { pattern: /^[^\s]*$/, message: "最多输入一个单词", trigger: "blur" },
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('请输入英文字符'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' }
        ],
      },
      sjformRules: {
        sjh: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确格式的手机号",
            trigger: "blur"
          },
          { min: 1, max: 15, message: "最多可输入15个数字", trigger: "blur" }
        ],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      showPicVisible: false,
      previewImg: "",
      editFlag: false,
       //企业基本信息
      jbxxData: {
        zwgsmc: "",
        tyshxydm: "",
        yyzzBase64: "",
        yjdz: "",
        frdb: "",
        frdbdh: "",
        lxr: "",
        lxrsj: "",
        cz: "",
        bgdh: "",
        dzyx: "",
        wz: "",
        sjztmc: "",
        shztmc: "",
        cjrmc: "",
        cjsj: "",
        xgrmc: "",
        xgsj: "",
        shrmc: "",
        shsj: "",
        zcdz: "",
        yjlxr:"",
        yjlxrsj:""
      },
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findInfoByQyid(this.qyid);
      }
    }
  },
  created: function() {
    this.getXzqhDataTree();
  },
 
  methods: {
    //行政区划级联选择数据
    getXzqhDataTree: function() {
      let vm = this;
      vm.$axios.post("/codelist/getYjdz").then(
        function(res) {
          vm.xzqhDataTree = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    
    //通过企业id查询基本信息数据
    findInfoByQyid: function(qyid) {
      this.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      let vm = this;
      vm.$axios.post("/qyjbxx/doFindByVo", params).then(
        function(res) {
          if (res.data.result != null && res.data.result != "") {
      //      if ( vm.currentUser.deptid == "GLYH" || res.data.result.sjzt == "01" || res.data.result.sjzt == "04") {
              
                vm.jbxxData = JSON.parse(JSON.stringify(res.data.result))
                //add by yushch 20200416
                if(vm.userType == "ENG" && vm.jbxxData.src!= null){
                  let arr = vm.jbxxData.src.split("/");
                  vm.jbxxData.srcmc = arr[arr.length-1];
                }
                //end
                if(vm.jbxxData.src != ""){
                  vm.jbxxData.imageUrl = vm.baseUrl + "/upload/" + vm.jbxxData.src;
                }
                vm.jbxxData.yjdz = vm.jbxxData.yjdzshengmc + vm.jbxxData.yjdzshimc + vm.jbxxData.yjdzxx;
              
                //编辑中，已驳回
                let tempForm = res.data.result;
                //处理分机号 add by yushch 20200408
                if(tempForm.bgdh != null){
                  let bgdhStr = tempForm.bgdh.split("分机号");
                  tempForm.bgdh = bgdhStr[0];
                  if(bgdhStr.length>1){
                    tempForm.bgdhfjh = bgdhStr[1];
                  }
                }
                
                //行政区划级联下拉处理
                var xzqhArray = [];
                xzqhArray.push(res.data.result.yjdzsheng);
                xzqhArray.push(res.data.result.yjdzshi);
                tempForm.xzqh = xzqhArray;
                tempForm.dzyx1 = tempForm.dzyx;
                vm.baseInforForm = tempForm;
                //曾用公司名称 记录当前中文公司名称
                vm.cygsmc = res.data.result.zwgsmc;
                if (
                  vm.baseInforForm.src !== null &&
                  vm.baseInforForm.src !== ""
                ) {
                  vm.baseInforForm.imageUrl =
                    vm.baseUrl + "/upload/" + vm.baseInforForm.src;
                }
                //vm.jbxxStatus = 1; //修改
                vm.qyid = res.data.result.qyid;
                vm.upLoadData.qyid = res.data.result.qyid;
                vm.$emit("getbaseInforData", vm.baseInforForm);
                //vm.$emit("getQyid",  vm.qyid);
              if(res.data.result.validateFlag == 'T'){
                vm.editFlag = false;
              }else{
                vm.editFlag = true;
              }

            // } else {
            //   //已提交，已审核 直接跳转到确认页
            //   this.$router.replace({
            //     name:"exhpredictionConfirm",
            //     query: { userid: vm.currentUser.userid, type: "BJ" }
            //   });
            // }
          }else{
            //location.reload();
          }
          vm.$emit("getLoading", false);
          //展商用户校验改没改密码
          if(vm.userType == "ZSYH"){
            vm.checkPasswordChg();
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    

    //营业执照图片上传成功回调方法
    picSuccess: function(res, file) {
      this.baseInforForm.src = res.src;
      this.baseInforForm.imageUrl = this.baseUrl + "/upload/" + res.src;
      //this.unsavedPicList.push(res.src);
    },
    //营业执照change
    PicChange: function(file, fileList) {
      var fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      var fileNameLength = file.name.length; //取到文件名长度
      var fileFormat = file.name.substring(fileName + 1, fileNameLength);
      const isPng = fileFormat.toLowerCase() == "png";
      const isJpg = fileFormat.toLowerCase() == "jpg";
      this.isPdf = fileFormat.toLowerCase() == "pdf";
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isPng && !isJpg && !this.isPdf) {
        this.$message.error("只能上传jpg、png格式的图片或单页pdf文件");
      } else if (!isLt2M) {
        this.$message.error("上传图片大小须小于5MB!");
      } else {
        this.delPicList.push(this.baseInforForm.src);
        //上次营业执照格式为pdf则删除同名pdf文件
        if (this.baseInforForm.yyzzgs == ".pdf") {
          if (this.baseInforForm.src != null && this.baseInforForm.src != undefined && this.baseInforForm.src != "") {
            var path = this.baseInforForm.src.split(".")[0];
            var pdfSrc = path + ".pdf";
            this.delPicList.push(pdfSrc);
          }
        }
        if (isPng || isJpg) {
          this.baseInforForm.yyzzgs = "";
        } else {
          this.baseInforForm.yyzzgs = ".pdf";
        }
      }
      return isLt2M && (isPng||isJpg||this.isPdf);
    },
    
    //基本信息提交（下一步）
    submitJbxx: function(formName) {
      let vm = this;
      vm.$refs[formName].validate(valid => {
        if (valid) {
          if (vm.qyid == 'newInsert') {
            //新增
            if ( vm.baseInforForm.dzyx1 != null && vm.baseInforForm.dzyx1 != "" && vm.baseInforForm.dzyx1 != undefined 
                  && vm.mailCheck == false && vm.userType == 'ZSYH') {
              vm.$message({
                message: "请对修改后的邮箱进行验证",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            } else if ( vm.baseInforForm.src == null || vm.baseInforForm.src == "") {
              vm.$message({
                message: "请上传企业营业执照",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            } else if(vm.baseInforForm.frdbdh == vm.baseInforForm.lxrsj){
              vm.$message({
                message: "备用联系人手机号不能与联系人手机号相同",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            }else {
              vm.$emit("getLoading", true);
              var params = {
              //  userid: vm.currentUser.userid,
                zwgsmc: vm.baseInforForm.zwgsmc,
                ywgsmc: vm.baseInforForm.ywgsmc,
                frdb: vm.baseInforForm.frdb,
                frdbdh: vm.baseInforForm.frdbdh,
                yjdzsheng: vm.baseInforForm.xzqh[0],
                yjdzshi: vm.baseInforForm.xzqh[1],
                yjdzxx: vm.baseInforForm.yjdzxx,
              //  bgdh: vm.baseInforForm.bgdh,
                cz: vm.baseInforForm.cz,
                lxr: vm.baseInforForm.lxr,
                lxrsj: vm.baseInforForm.lxrsj,
                wz: vm.baseInforForm.wz,
                dzyx: vm.baseInforForm.dzyx1,
                sjzt: "01", //编辑中
                deleteFlag: "N",
                cjrid: vm.currentUser.userid,
                cjrmc: vm.currentUser.username,
                src: vm.baseInforForm.src,
                yyzzgs: vm.baseInforForm.yyzzgs,
                gsjc: vm.baseInforForm.gsjc,
                ywgsjc: vm.baseInforForm.ywgsjc,
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.username,
                validateFlag: 'T',
                yjlxr: vm.baseInforForm.yjlxr,
                yjlxrsj: vm.baseInforForm.yjlxrsj,
                zcdz: vm.baseInforForm.zcdz
              };
              if(vm.baseInforForm.bgdhfjh == "" || vm.baseInforForm.bgdhfjh == null || vm.baseInforForm.bgdhfjh == undefined){
                params.bgdh = vm.baseInforForm.bgdh;
              }else{
                params.bgdh = vm.baseInforForm.bgdh + "分机号" + vm.baseInforForm.bgdhfjh;
              }
              //add by yushch 20200414 管理员登录userid带入选择的企业userid
              if(vm.userType == 'ZSYH'){
                params.userid = vm.currentUser.userid;
              }else{
                params.userid = vm.baseInforForm.userid;
              }
              //end add
              vm.$axios.post("/qyjbxx/doInsertByVo", params).then(
                function(res) {
                  if (res.data.result != null && res.data.result != "") {
                    vm.$message({
                      message: "企业基本信息暂存成功",
                      type: "success"
                    });
                    vm.$emit("getLoading", false);
                    //vm.$emit("getActive",  1);
                    vm.qyid = res.data.result.qyid;
                    vm.$emit("getQyid",  vm.qyid);
                    vm.baseInforForm.qyid = res.data.result.qyid;
                    vm.upLoadData.qyid = res.data.result.qyid;
                    
                    //删除旧营业执照
                    if (vm.delPicList.length > 0) {
                      vm.$axios.post("/qycpjs/delPic", vm.delPicList).then(
                        function(res) {
                          vm.delPicList = [];
                        }.bind(vm),
                        function(error) {
                          console.log(error);
                        }
                      );
                    }
                    vm.unsavedPicList = [];
                    //给营业执照移动到qyid文件夹中
                    var params = {
                      qyid: vm.qyid,
                      src: vm.baseInforForm.src,
                      yyzzgs: vm.baseInforForm.yyzzgs
                    };
                    vm.$axios.post("/qyjbxx/movePic", params).then(
                      function(res) {
                        vm.baseInforForm.src = res.data.src;
                      }.bind(vm),
                      function(error) {
                        console.log(error);
                      }
                    );
                    vm.editFlag = false;
                    this.findInfoByQyid(this.qyid);
                  } else {
                    vm.$message({
                      message: "企业基本信息暂存失败",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  console.log(error);
                }
              );
            }
          } else {
            //修改
            //邮箱修改且邮箱验证通过flag为false
            if (
              vm.baseInforForm.dzyx1 != null &&
              vm.baseInforForm.dzyx1 != "" &&
              vm.baseInforForm.dzyx1 != undefined &&
              vm.baseInforForm.dzyx != vm.baseInforForm.dzyx1 &&
              vm.mailCheck == false &&
              vm.userType == 'ZSYH'
            ) {
              vm.$message({
                message: "请对修改后的邮箱进行验证",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            } else if (
              vm.baseInforForm.src == null ||
              vm.baseInforForm.src == ""
            ) {
              vm.$message({
                message: "请上传企业营业执照",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            } else if(vm.baseInforForm.frdbdh == vm.baseInforForm.lxrsj){
              vm.$message({
                message: "备用联系人手机号不能与联系人手机号相同",
                type: "warning"
              });
              console.log("error submit!!");
              return false;
            }else {
              vm.$emit("getLoading", true);
              var params = {
                  qyid: vm.baseInforForm.qyid,
                  zwgsmc: vm.baseInforForm.zwgsmc,
                  ywgsmc: vm.baseInforForm.ywgsmc,
                  frdb: vm.baseInforForm.frdb,
                  frdbdh: vm.baseInforForm.frdbdh,
                  yjdzsheng: vm.baseInforForm.xzqh[0],
                  yjdzshi: vm.baseInforForm.xzqh[1],
                  yjdzxx: vm.baseInforForm.yjdzxx,
                  cz: vm.baseInforForm.cz,
                  lxr: vm.baseInforForm.lxr,
                  lxrsj: vm.baseInforForm.lxrsj,
                  wz: vm.baseInforForm.wz,
                  dzyx: vm.baseInforForm.dzyx1,
                  //yyzz:vm.baseInforForm.yyzz,
                  xgrid: vm.currentUser.userid,
                  xgrmc: vm.currentUser.username,
                  src: vm.baseInforForm.src,
                  yyzzgs: vm.baseInforForm.yyzzgs,
                  gsjc: vm.baseInforForm.gsjc,
                  ywgsjc: vm.baseInforForm.ywgsjc,
                  validateFlag:'T',
                  yjlxr: vm.baseInforForm.yjlxr,
                  yjlxrsj: vm.baseInforForm.yjlxrsj,
                  zcdz: vm.baseInforForm.zcdz
                };
              //判断当前公司名称是否修改
              if (vm.cygsmc != vm.baseInforForm.zwgsmc) {
                params.cygsmc = vm.cygsmc;
              }
              //分机号
              if(vm.baseInforForm.bgdhfjh == "" || vm.baseInforForm.bgdhfjh == null || vm.baseInforForm.bgdhfjh == undefined){
                params.bgdh = vm.baseInforForm.bgdh;
              }else{
                params.bgdh = vm.baseInforForm.bgdh + "分机号" + vm.baseInforForm.bgdhfjh;
              }
              vm.$axios.post("/qyjbxx/doUpdateByVO", params).then(
                function(res) {
                  if (res.data.result > 0) {
                    vm.cygsmc = vm.baseInforForm.zwgsmc;
                    vm.$message({
                      message: "企业基本信息暂存成功",
                      type: "success"
                    });
                    vm.$emit("getLoading", false);
                    //vm.$emit("getActive",  1);
                    if (vm.delPicList.length > 0) {
                      vm.$axios.post("/qycpjs/delPic", vm.delPicList).then(
                        function(res) {
                          vm.delPicList = [];
                        }.bind(vm),
                        function(error) {
                          console.log(error);
                        }
                      );
                    }
                    vm.unsavedPicList = [];

                    vm.editFlag = false;
                    this.findInfoByQyid(this.qyid);
                  } else {
                    vm.$message({
                      message: "企业基本信息暂存失败",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  console.log(error);
                }
              );
            }
          }
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
    },
    //手机修改验证
    openSjYz: function() {
      this.dialogSjFormVisible = true;
    },
    //关闭手机验证对话
    closeDialog: function() {
      this.dialogSjFormVisible = false;
      this.sjform.sjh = "";
      this.sjform.yzm = "";
      this.$refs["sjform"].resetFields();
    },
    //获取短信验证码
    getMessageCode: function() {
      let vm = this;
      vm.sjform.yzm = "";
      if (/^1[3456789]\d{9}$/.test(vm.sjform.sjh)) {
        vm.messageCodeText = "发送中...";
        //$("#mobile-btn").attr("disabled", "disabled");
        this.mobileBtnDisable = true;
        vm.$axios.get("/signin/sendMessage?phone=" + vm.sjform.sjh).then(
          function(res) {
            vm.messageCodeReal = res.data.msg;
            var count = vm.time;
            vm.timer = setInterval(() => {
              if (count == 0) {
                clearInterval(vm.timer);
                vm.timer = null;
                vm.messageCodeText = "获取验证码";
                this.mobileBtnDisable = false;
              } else {
                vm.messageCodeText = count + "秒后获取";
                count--;
                this.mobileBtnDisable = true;
              }
            }, 1000);
          }.bind(vm),
          function(error) {
            console.log(error);
          }
        );
      }
    },
    //手机验证码form提交
    sjformSubmit: function(formName) {
      if (this.sjform.sjh != null && this.sjform.sjh != "") {
        if (
          this.sjform.yzm == this.messageCodeReal &&
          this.messageCodeReal != ""
        ) {
          this.baseInforForm.lxrsj = this.sjform.sjh;
          this.dialogSjFormVisible = false;
        } else {
          this.$message({
            message: "验证码错误",
            type: "error"
          });
        }
      } else {
        this.$message({
          message: "请输入手机号",
          type: "error"
        });
      }
    },
    //邮箱验证表单提交
    yxformSubmit: function() {
      if (this.yxform.yzm == this.mailCodeReal) {
        this.mailCheck = true;
        this.checkedMailAddress = this.baseInforForm.dzyx1;
        this.dialogYxFormVisible = false;
        this.$message({
          message: "邮箱验证成功",
          type: "success"
        });
      } else {
        this.$message({
          message: "验证码错误",
          type: "error"
        });
      }
    },
    //邮箱修改验证
    openYxYz: function() {
      let vm = this;
      if(vm.baseInforForm.dzyx1 !=null && vm.baseInforForm.dzyx1 !='' && vm.baseInforForm.dzyx1 !=undefined){
        //查询邮箱是否注册
        vm.$axios
          .get("/qyjbxx/getMailNum/" + vm.baseInforForm.dzyx1 + "/static")
          .then(
            function(res) {
              //session失效
              if (res.data.result == undefined) {
                vm
                  .$confirm("用户登陆超时，请重新登陆。", "提示", {
                    confirmButtonText: "是",
                    cancelButtonText: "否",
                    type: "warning"
                  })
                  .then(() => {
                    window.location.href = "/templates/login.html";
                  })
                  .catch(() => {});
              } else if (res.data.result == 0) {
                vm.mailCodeText = "发送中...";
                vm.mailBtnDisable = true;
                vm.$axios
                  .get("/signin/sendMail?mail=" + vm.baseInforForm.dzyx1)
                  .then(
                    function(res) {
                      vm.mailCodeReal = res.data.msg;
                      var count = vm.time2;
                      vm.timer2 = setInterval(() => {
                        if (count == 0) {
                          clearInterval(vm.timer2);
                          vm.timer2 = null;
                          vm.mailCodeText = "验证";
                          this.mailBtnDisable = false;
                        } else {
                          vm.mailCodeText = count + "秒后获取";
                          count--;
                          vm.mailBtnDisable = true;
                        }
                      }, 1000);
                      vm.dialogYxFormVisible = true;
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
              } else if (vm.baseInforForm.dzyx1 == vm.baseInforForm.dzyx) {
                vm.$message({
                  message: "此邮箱已通过验证",
                  type: "success"
                });
                return false;
              } else {
                vm.$message({
                  message: "此邮箱已被注册,请更换邮箱",
                  type: "warning"
                });
                return false;
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
    //  }
      }
    },

    //关闭邮箱验证对话
    closeYxDialog: function() {
      this.dialogYxFormVisible = false;
      this.yxform.yzm = "";
      this.$refs["yxform"].resetFields();
    },
    //邮箱change判断需不需要重新验证
    dzyxChange: function() {
      if (
        this.checkedMailAddress != this.baseInforForm.dzyx1 &&
        this.checkedMailAddress != ""
      ) {
        this.mailCheck = false;
      }
    },

    checkPasswordChg: function(){
      let vm = this;
      var passwordChgFlag = vm.currentUser.passwordChgFlag;
      if (passwordChgFlag == "F") {
        vm.$alert(
          "为保证信息安全，请点击右上角用户名，前往用户中心，按照密码校验规则修改密码",
          '提示',
          {
            confirmButtonText: '确定',
            type: 'warning'
          });
      }
    },


    imgPreview: function(val) {
      this.previewImg = val;
      this.showPicVisible = true;
    },
   
   
    //英文展商下载附件 add by yushch 20200416
    download: function(){
      window.open(window.config.domain + "/qyjbxx/downloadFj?src="+this.jbxxData.src);
    },
    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findInfoByQyid(this.qyid);
    }
  }
};
</script>

<style lang="scss">
#baseInfoEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  
  #previewImgDialog .el-dialog {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEdit/BaseInfo2.vue